import { Box, Button, Grid, Typography, makeStyles } from "@material-ui/core";
import Slide from "../../../../../../components/Slide";
import QHeader from "../../../../../../components/QHeader";
import { theme } from "../../../../../../theme";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  button: {
    marginLeft: "12px",
    color: "white !important",
    borderColor: "white",
  },
}));

export default function TeilDesTeams() {
  const classes = useStyles();
  return (
    <Slide background={{ width: "100dvw", color: theme.palette.primary.main }}>
      <Grid container spacing={5} alignItems="center">
        <Grid item xs={1}></Grid>
        <Grid item xs={10}>
          <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center">
            <Typography
              variant="body1"
              align="center"
              style={{ color: "white" }}
            >
              DEINE KARRIERE BEI SSV-KROSCHKE
            </Typography>
            <QHeader
              color="white"
              textAlign="center"
              title={<>Werde Teil des Teams und arbeite beim innovativsten <span className="nobr">C-Teile-Spezialisten</span> Deutschlands!</>}
            />
            <Button
              href="#allgemeines/1"
              variant="outlined"
              size="medium"
              className={clsx(classes.button, "gsap-headline-button")}
              endIcon={<ChevronRightIcon />}
            >
              SSV-Kroschke auf einen Blick
            </Button>
          </Box>
        </Grid>
        <Grid item xs={1}></Grid>
      </Grid>
    </Slide>
  );
}
